import {
    RouterModule,
    Routes,
} from '@angular/router'
import {
    DashboardCalendarPageComponent,
    DashboardLayoutComponent,
    DashboardTimelinePageComponent,
} from '@undock/dashboard/ui'
import { NgModule } from '@angular/core'

const routes: Routes = [
    {
        path: '',
        component: DashboardLayoutComponent,
        children: [
            { path: 'timeline', component: DashboardTimelinePageComponent },
            { path: 'calendar', component: DashboardCalendarPageComponent },
            { path: 'calendar/:view', component: DashboardCalendarPageComponent },

            /**
             * @warning The Calendar view is allowed only for early adopters
             *          Unspecified users are redirected to dashboard/timeline
             */
            { path: '', pathMatch: 'full', redirectTo: 'calendar' },
        ]
    }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DashboardRoutingModule {}
